<template>
  <div class="shipping-checkpoint-form" v-if="shippingEdit">
    <b-form @submit.stop.prevent="editCheckpoint">
      <b-row>
        <b-form-group class="col-8">
          <shipping-checkpoint-form-address :new-address="newAddress" :checkpoint="checkpoint" v-if="newAddress || (shippingEdit['address_' + checkpoint] || shippingEdit.fields_revision)" :shipping="shippingEdit" @success="setPlace" :disabled="!isAddressEditable" />
        </b-form-group>
        <b-form-group class="col-4">
          <label for="extra" v-translate>Floor, door, etc.</label>
          <b-form-input id="extra" v-model="shippingEdit[checkpoint + '_extra']" />
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group class="col-12">
          <label for="contact" v-translate>Contact Name</label>
          <b-form-input id="contact" v-model="shippingEdit[checkpoint + '_contact']" required />
        </b-form-group>
        <b-form-group class="col-md-6 col-12">
          <label for="email" v-translate>Contact E-mail</label>
          <b-form-input id="email" v-model="shippingEdit[checkpoint + '_email']" />
        </b-form-group>
        <b-form-group class="col-md-6 col-12">
          <label for="phone" v-translate>Contact Phone</label>
          <input-phone id="phone" :phone-number="shippingEdit[checkpoint + '_phone']" @update="setPhone" :default-country-code="defaultCountryCode" />
        </b-form-group>
        <b-form-group class="col-md-6 col-12">
          <label for="meta">
            <translate>Special instructions</translate>
            <em class="text-info"><small v-translate>(up to 2048 characters)</small></em>
          </label>
          <b-form-textarea id="meta" v-model="shippingEdit[checkpoint + '_meta']" :rows="3" :max-rows="6" @update="countdown(checkpoint + '_meta', 2048)" :state="invalid[checkpoint + '_meta']" style="overflow-y: auto;" />
          <p class="text-right mb-0" v-bind:class="{'text-danger': invalid[checkpoint + '_meta'] === false }"><small>{{limits[checkpoint + '_meta']}}</small></p>
          <small class="form-text text-muted"><span v-translate="{courierI18n: this.courierI18n}">Is there any special instruction for our %{courierI18n} at this checkpoint?</span><br>
          <translate>i.e.</translate> <em v-translate>The door bell is not working</em></small>
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group class="col-12 mt-4">
          <b-button type="submit" variant="secondary" size="md" v-translate>Update Information</b-button>
          <b-button type="button" @click="emitCancel" variant="outline-secondary" size="md" v-translate>Cancel</b-button>
        </b-form-group>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import InputPhone from '@/components/InputPhone'
import ShippingCheckpointFormAddress from '@/components/ShippingCheckpointFormAddress'

export default {
  name: 'ShippingCheckpointForm',
  components: {
    InputPhone,
    ShippingCheckpointFormAddress
  },
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    },
    checkpoint: {
      type: String,
      default: 'to'
    },
    newAddress: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shippingEdit: {},
      invalid: {},
      limits: {}
    }
  },
  computed: {
    moovaCountries() {
      return window.countries.map(x => x.iso_code)
    },
    defaultCountryCode() {
      return this.shipping.to_country_iso_code || (this.shipping.company ? this.shipping.company.country_iso_code : 'AR')
    },
    isAddressEditable() {
      if (this.shipping.status) {
        return this.shipping.status === 'DRAFT' ||
          this.shipping.status === 'READY' ||
          (
            this.shipping.status === 'INCIDENCE' &&
            this.shipping.status_history &&
            this.shipping.status_history.length > 0 &&
            this.shipping.status_history[0].details &&
            this.shipping.status_history[0].details.reason === 'incorrect_address' ||
            this.shipping.status_history[0].details.reason === 'absent_client' ||
            this.shipping.status_history[0].details.reason === 'wrong_address'
          )
      }
    }
  },
  mounted() {
    this.shippingEdit = {...this.shipping}
    this.countdown(this.checkpoint + '_meta', 2048)
    this.shippingEdit[this.checkpoint + '_phone'] = this.shippingEdit[this.checkpoint + '_phone'] || ' '
  },
  methods: {
    setPlace($e) {
      console.log($e)
      this.shippingEdit = {...this.shippingEdit, ...$e} // Object.assign({}, this.shippingEdit, $e)
    },
    editCheckpoint() {
      if (!this.newAddress) {
        let fieldsToUpdate = this.deepDiffMapper().fieldsToUpdate(this.shippingEdit, this.shipping)
        if (this.shippingEdit.force_place_id) {
          delete fieldsToUpdate.force_place_id
          fieldsToUpdate = {...fieldsToUpdate, ...{[this.checkpoint + '_place_id']: this.shippingEdit[this.checkpoint + '_place_id']}}
        }
        this.$http.patch(this.$appConfig.api.baseUrl + 'guest/shippings/' + this.shipping.id + '?hash=' + this.$route.query.hash, fieldsToUpdate)
          .then(() => {
            this.emitSuccess()
          })
      } else {
        this.emitSuccess()
      }
    },
    setPhone($e) {
      this.shippingEdit[this.checkpoint + '_phone'] = $e
    },
    countdown(value, limit) {
      this.limits[value] = this.shippingEdit[value] ? limit - this.shippingEdit[value].length : null
      this.invalid[value] = this.shippingEdit[value] ? this.shippingEdit[value].length <= limit : null
    },
    emitSuccess() {
      this.$emit('success', this.shippingEdit)
    },
    emitCancel() {
      this.$emit('cancel', true)
    }
  }
}
</script>
